let html = `
<svg><use xlink:href="#sprite-collection"></use></svg>
`

export default html